type NoSsrProps<T> = {
  children: T;
};

export function NoSsr<T>({ children }: NoSsrProps<T>): T | null {
  if (typeof window === 'undefined') {
    return null;
  }

  return children;
}
